import React from "react";
interface StepHeadingProps {
  title: React.ReactNode;
  subtitle: string;
}
export function StepHeading({
  title,
  subtitle
}: StepHeadingProps) {
  return <div className="mb-10" data-id="element-124" data-mp="27zovzxms9jx7">
      <h1 className="text-4xl font-bold leading-[1.1] tracking-tight text-ink md:text-6xl" data-id="element-125" data-mp="231vrd914oxz1">{title}</h1>
      <p className="mt-4 max-w-xl text-base text-muted md:text-lg" data-id="element-126" data-mp="1z1cxzajl7juq">{subtitle}</p>
    </div>;
}